import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { Shareholder } from "@/services/shareholder/types";
import { AuthService } from "@/services/auth/AuthService";

import Swal from "sweetalert2";

export const useAuthStore = defineStore("auth", () => {
  const authService = new AuthService();

  const token = ref<string | null>(localStorage.getItem("token"));
  const user = ref<Shareholder | null>(
    localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user") as string)
      : null
  );

  const updateUserErrors = ref<any>({});
  const updateUserIsPending: boolean | undefined = undefined;

  const setToken = (newToken: string) => {
    token.value = newToken;
    localStorage.setItem("token", newToken);
  };

  const setUser = (newUser: Shareholder) => {
    user.value = newUser;
    localStorage.setItem("user", JSON.stringify(newUser));
  };

  const logout = () => {
    token.value = null;
    user.value = null;
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("activeAccount");
  };

  const setUserId = (id: number) => {
    localStorage.setItem("user_id", String(id));
  };

  const updateUser = async () => {
    try {
      if (user.value) {
        await authService.changeInfo(user.value);
        if (token.value) await authService.getPerfil(token.value);
        setUser(user.value);

        return true;
      }
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.errors) {
        updateUserErrors.value = {...error.response.data.errors};
        
        console.log(updateUserErrors.value);
        Swal.fire(
          "Error!",
          "Los datos del usuario no han sido modificados. Inténtelo nuevamente.",
          "error"
          );
          
          }
          
        }
        return false;
  };

  const userIsAuthenticated = computed(() => user.value !== null);

  const getUserId = () => localStorage.getItem("user_id");

  return {
    authService,

    token,
    user,
    setToken,

    setUser,

    updateUser,
    updateUserErrors,
    updateUserIsPending,

    logout,
    setUserId,
    userIsAuthenticated,
    getUserId,
  };
});
